<template>
	<svg width="44" height="44" viewBox="0 0 44 44" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
		<rect x="7.75" y="10.75" width="28.5" height="22.5" fill="#E5F6FD" stroke="#0074B5" stroke-width="1.5"/>
		<rect x="17.7383" y="17.5078" width="8.52539" height="8.98047" rx="2.25" fill="#E5F6FD" stroke="#0074B5" stroke-width="1.5"/>
	</svg>
</template>
